<template>
  <f7-page name="home" class="BG home">
    <!-- Top Navbar -->
    <f7-navbar :sliding="false" >
      <f7-nav-left>
        <f7-link  panel-open="left" class="menu-icon"><i class="az-icon-menu"></i></f7-link>
      </f7-nav-left>
      <!-- <f7-nav-title >AZConnectHH</f7-nav-title> -->
      <!-- <f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right> -->
      <!-- <f7-nav-title-large sliding>AZConnectNN</f7-nav-title-large> -->
    </f7-navbar>
    <!-- Toolbar-->

    <!-- Page content-->
    <!-- App Logo-->


    <f7-block>
      <f7-row>
        <div class="col-40 col-sm-0 ">
          <div class="left-az-logo">
             <img src="../assets/images/home-logo.png" alt=""/>
          </div>
        </div>
        <div class="col-60 col-sm-100 ">
        <div class="app-logo">
          <div class="app-logo-dev left-app-logo yellow" >AZ</div>
          <div class="app-logo-dev right-app-logo white">
            <span >| CONNECT</span>
          </div>
        </div>
        <div class="app-grid">
          <f7-block >
            <f7-row>
              <f7-col width="100">
                <f7-link href="/calendar/">
                  <div class="home-blocks">
                    <div class="home-block-content ">
                      <div class="home-icon">
                        <i class="az-icon-calendar-date-schedule-appointment"></i>
                      </div>
                      <p>Calendar</p>
                    </div>
                  </div>
                </f7-link>
              </f7-col>
              <!-- Upcoming -->
              <f7-col width="100">
                <f7-link href="/upcoming/">
                  <div class="home-blocks">
                    <div class="home-block-content ">
                      <div class="home-icon">
                        <i class="az-icon-calendar-date-schedule"></i>
                      </div>
                      <p>My Events</p>
                    </div>
                  </div>
                </f7-link>
              </f7-col>
            </f7-row>
            <f7-row>
              <!-- Feedback -->
              <f7-col width="100" v-if="$root.user.user_type != 'astrazeneca_sales'">
                <f7-link href="/articles/">
                  <div class="home-blocks">
                    <div class="home-block-content ">
                      <div class="home-icon">
                        <i class="az-icon-document-copy-duplicate-office"></i>
                      </div>
                      <p>Articles</p>
                    </div>
                  </div>
                </f7-link>
              </f7-col>
              <f7-col width="100">
                <f7-link href="/news/">
                  <div class="home-blocks">
                    <div class="home-block-content ">
                      <div class="home-icon">
                        <i class="az-icon-website-web-site-page-internet"></i>
                      </div>
                      <p>News</p>
                    </div>
                  </div>
                </f7-link>
              </f7-col>
              <f7-col width="100">
                <f7-link href="/contact/">
                  <div class="home-blocks">
                    <div class="home-block-content ">
                      <div class="home-icon">
                        <i class="az-icon-mail-email-letter-enveloppe"></i>
                      </div>
                      <p>Contact Us</p>
                    </div>
                  </div>
                </f7-link>
              </f7-col>
            </f7-row>
          </f7-block>
        </div>
        </div>

      </f7-row>
    </f7-block>

  </f7-page>
</template>

<script>
import logoSide from '../components/logo-side.vue';
export default {
  components: { logoSide },
}
</script>

<style>

</style>
